module.exports = __webpack_public_path__ + "static/media/12.27d59175.jpg";